import { makeContact } from 'src/main/factories/pages'

export default makeContact
